var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-lg mx-auto p-4 sm:py-16"},[_c('UserActivationForm',{attrs:{"activation-url":_vm.activationUrl},on:{"user-activated":_vm.onUserActivated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }